import React from 'react';
import slackLogo from './slack_logo.png';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

function SlackLogo({ ...props }) {
  const { tr } = useTranslation();
  return <img src={slackLogo} alt={tr('perform.logos.slack.alt')} {...props} />;
}

export default SlackLogo;
